import '@nike/eds/dist/index.css'
import { useLogoutMutation } from 'api/authentication'
import { dispatch } from 'api/redux'
import { UsernamePasswordModal } from 'components/authentication-modal'
import { Footer } from 'components/footer'
import { Header } from 'components/header'
import { LoadingOverlay } from 'components/loading-overlay'
import { SnackBar, showSnackbar } from 'components/snackbar'
import { Unauthorized } from 'pages/unauthorized'
import { UnitHandling } from 'pages/UnitHandling'
import { useTranslation } from 'react-i18next'
import { useIdleTimer } from 'react-idle-timer'
import { Route, Routes } from 'react-router-dom'
import { isBrimley } from 'utils/dcContext'
import { useAuthentication } from 'utils/useAuthentication'

import './App.css'

function App () {
  const { t } = useTranslation()
  const { isAuthenticated, storeCredentialsAndRedirectToAuthPoint, isFetchingAuth } = useAuthentication()
  const [logout] = useLogoutMutation()
  const params = new URLSearchParams(window.location.search)

  if (params.get('loginError')) {
    dispatch(showSnackbar(t('snackbar.error_credentials'), 'error'))
  }

  useIdleTimer({
    onIdle: () => {
      logout()
    },
    timeout: 1000 * 60 * 40
  })

  return (
    <>
      <Header />
      <SnackBar />
      {isFetchingAuth && <LoadingOverlay message={t('loading')} />}
      {isAuthenticated
        ? <Routes>
          <Route path="/*" element={<UnitHandling />} />
        </Routes>
        : isBrimley
          ? <UsernamePasswordModal onSubmit={storeCredentialsAndRedirectToAuthPoint} />
          : <Unauthorized />
      }
      <Footer />
    </>
  )
}

export default App
